/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Select, { components, IndicatorProps } from 'react-select';

import classNames from 'classnames';

import ArrowDownIcon from './icons/arrow-down-icon.svg';
import ArrowUpIcon from './icons/arrow-up-icon.svg';

import './app-select.scss';

const DropdownIndicator = (props: IndicatorProps<any, any>) => (
  <components.DropdownIndicator {...props}>
    <img
      src={props.selectProps.menuIsOpen ? ArrowUpIcon : ArrowDownIcon}
      alt=""
    />
  </components.DropdownIndicator>
);

interface AppSelectProps {
  isMulti?: boolean;
  options: { value: string; label: string }[];
  placeholder?: string;
  onChange?: (
    val:
      | { value: string; label: string }
      | null
      | { value: string; label: string }[]
  ) => void;
  value?: { value: string; label: string }[] | { value: string; label: string };
  sm?: boolean;
  top?: boolean;
  disabled?: boolean;
}

const AppSelect: React.FC<AppSelectProps> = ({
  isMulti,
  disabled,
  top,
  sm,
  value,
  placeholder,
  options,
  onChange,
}) => (
  <Select
    onChange={onChange}
    isMulti={isMulti}
    options={options}
    components={{ DropdownIndicator }}
    placeholder={placeholder}
    value={value}
    className={classNames('react-select-container', {
      'react-select-container--sm': sm,
    })}
    isDisabled={disabled}
    menuPlacement={top ? 'top' : undefined}
    classNamePrefix="react-select"
  />
);

export default AppSelect;
